import {Outlet} from "react-router-dom";
import AppBottomNav from "../components/AppBottomNav";
import {useEffect} from "react";

export default function Root() {

  useEffect(() => {
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
//         const firebaseConfig = {
//             apiKey: "AIzaSyBsPPhHPV7jJw9oEdmqhBTPnh6WUNQ2_6s",
//             authDomain: "polling-app-ux.firebaseapp.com",
//             projectId: "polling-app-ux",
//             storageBucket: "polling-app-ux.appspot.com",
//             messagingSenderId: "894491090593",
//             appId: "1:894491090593:web:7a399818abe85bf877dae0",
//             measurementId: "G-859V7NTJHR"
//         };

// Initialize Firebase
//         const app = initializeApp(firebaseConfig);
//         const analytics = getAnalytics(app);
  }, [])

  return (
    <>
      <div>
        <Outlet/>
        <br/><br/><br/><br/>
        <AppBottomNav/>
      </div>
    </>
  );
}
